var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.383564 11.0671L10.9913 0.386228C11.5027 -0.128743 12.3323 -0.128743 12.8437 0.386228L14.0811 1.63216C14.592 2.14658 14.5925 2.97977 14.0833 3.49529L5.67623 11.9997L14.0827 20.5047C14.5925 21.0202 14.5914 21.8534 14.0805 22.3678L12.8432 23.6138C12.3318 24.1287 11.5022 24.1287 10.9907 23.6138L0.383564 12.9324C-0.127855 12.4174 -0.127855 11.582 0.383564 11.0671Z",
    fill: "#0e0333",
    fillOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.b2153e5d5433b89f6dfd64eac23f42e3.svg";
export { ForwardRef as ReactComponent };